<template>
  <div 
    class="title-container"
    style="margin-top: 3rem; margin-bottom: 3rem;"
  >
    <div class="d-flex align-items-center">
      <div class="slash-container mr-2">
        <img class="slash" src="/img/05_slash.svg"/>
      </div>
      <h1 class="font-weight-bold mb-0 text-gray">{{ title }}</h1>
    </div>
  </div>
</template>


<script>
export default {
  name: 'Title',
  props: {
    title: {
      type: String,
      required: true,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.slash {
  width: 3rem;
  height: 3rem;
}
.text-gray {
  color: #31443D;
}
</style>